
    import './styles.scoped.css';
    export default {
  "empty-appear": "awsui_empty-appear_n4qlp_1bggj_93",
  "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_n4qlp_1bggj_1",
  "root": "awsui_root_n4qlp_1bggj_119",
  "empty": "awsui_empty_n4qlp_1bggj_93",
  "row": "awsui_row_n4qlp_1bggj_161",
  "row-control": "awsui_row-control_n4qlp_1bggj_165",
  "field": "awsui_field_n4qlp_1bggj_169",
  "add-button": "awsui_add-button_n4qlp_1bggj_173",
  "remove-button": "awsui_remove-button_n4qlp_1bggj_177",
  "button-container-haslabel": "awsui_button-container-haslabel_n4qlp_1bggj_181",
  "button-container-nolabel": "awsui_button-container-nolabel_n4qlp_1bggj_185",
  "divider": "awsui_divider_n4qlp_1bggj_189",
  "additional-info": "awsui_additional-info_n4qlp_1bggj_193",
  "right-align": "awsui_right-align_n4qlp_1bggj_239"
};
  